import makeUrl from '@/utils/makeUrl';
const siteApiPre = `/api/site`;
const siteApiList = [
	// 发送验证码
	'sendCode',
	// 搜索商务楼
	'searchBuilding',
	// 搜索地址
	'searchAddress',
	// 更改绑定手机
	'bindAgain',
	// 根据定位地址获取附近位置
	'getAround',
	// 市列表
	'area',
	// 绑定手机
	'bindPhone',
	// 获取微信sdk基本信息
	'getWxConfig',
	// 获取企业微信sdk基本信息
	'getCorpConfig',
	// 授权
	'getUserid',
	// 判断当前定位城市是否有门店
	'checkArea',
];
const siteApi = {};

siteApiList.forEach(key => {
	siteApi[`${key}Url`] = makeUrl(siteApiPre, key);
});

// 更改绑定手机号
siteApi.bindAgainUrl = `/api/site/bindAgain`;

// 发送验证码
siteApi.sendCodeUrl = `/api/site/sendCode`;
export default siteApi;